import View from './View'
import { createDOM, updateSpriteSheet, getScreenRatio } from './helpers/DOMHelper'
import { ease, easeInWord, easeOutWord } from './helpers/EaseHelper'
import { getActionFromId } from './helpers/DataHelper'
import Timeline from './Timeline'

/**
 * class Action
 */

export const ACTION_ROPE_LARGE = 'action-rope-large'
export const ACTION_CUT = 'action-cut'
export const ACTION_SCRATCH = 'action-scratch'
export const ACTION_SNORT = 'action-snort'
export const ACTION_ROPE = 'action-rope'

export const STATE_SHOW = 'action--show'
export const STATE_HIDE_INTRO = 'action--hide-intro'
export const STATE_HIDE = 'action--hide'
export const STATE_HIDE_BOOK_CLOSE = 'action--hide-book-close'

const COUNT_FRAME_MAX = 35
const DELAY_SWITCH = 1500
const DELAY_SHOW = 4000
const DELAY_ACTION_LOOP = DELAY_SHOW + 1000
const DELAY_HIDE = 500
class Action extends View {
  /**
   * constructor
   */
  constructor (el, onStateChange = () => {}) {
    super(el, onStateChange)
    this.state = STATE_HIDE
    this.type = ACTION_SCRATCH
    this.onStart = () => {}
    this.onUpdate = () => {}
    this.onComplete = () => {}
    this.words = []
    this.sprite = null
    this.timeline = new Timeline()
    this.switched = false
    this.timeoutActionLoop = null
    this.timeoutActionShow = null
    this.messageEnabled = true
  }

  setAction (id, startHandler, updateHandler, completeHandler, debug) {
    const { sentence, words, sprite, type } = getActionFromId(id)
    const switchDOM = createDOM('span', 'action__word action__word--switch')
    const cursor = createDOM('div', `action__picto action__picto-${type.slice(6)}`)
    const message = createDOM('div', 'action__message text__action--message', 'drag & drop')
    const createSwitch = words => {
      const wordLightDOM = createDOM('span', 'action__word--light', words[0])
      const timelineComplete = () => this.switchTransition()
      const timelineUpdate = ratio => {
        message.style.visibility = (ratio > 0.01) ? 'hidden' : 'visible'
        this.emit('update')
        this.onUpdate(ratio)
      }
      if (sprite) {
        this.sprite = sprite ? createDOM('div', 'action__sprite') : null
        this.sprite.style.backgroundImage = `url("${sprite}")`
        switchDOM.appendChild(this.sprite)
      } else {
        this.sprite = null
      }
      switchDOM.appendChild(wordLightDOM)
      switchDOM.appendChild(cursor)
      if (this.messageEnabled) switchDOM.appendChild(message)
      this.timeline.setTimeline(switchDOM, type, cursor, timelineUpdate, timelineComplete)
      return switchDOM
    }
    const createWord = word => {
      switch (word) {
        case '<br>': return createDOM('br')
        case '<%switch%>': return createSwitch(words)
        default: return createDOM('span', 'action__word', word)
      }
    }
    const sentenceDOM = createDOM('p', 'text__action')
    const chapterDOM = createDOM('span', 'action__word action__word--chapter text__action-chapter', (id + 1))

    clearTimeout(this.timeoutActionLoop)
    clearTimeout(this.timeoutActionShow)

    sentenceDOM.appendChild(chapterDOM)

    this.words = [chapterDOM]
    let wordDOM
    sentence.split(' ').map(word => {
      wordDOM = createWord(word)
      sentenceDOM.appendChild(wordDOM)
      sentenceDOM.appendChild(document.createTextNode('\u00A0'))
      this.words.push(wordDOM)
      return wordDOM
    })

    this.view.innerHTML = ''
    this.view.appendChild(sentenceDOM)

    this.type = type
    this.switched = false
    this.onStart = startHandler || (() => {})
    this.onUpdate = updateHandler || (() => {})
    this.onComplete = completeHandler || (() => {})
  }

  switchTransition () {
    this.switched = true
    this.messageEnabled = false
    ease({ framecount: 0 })
      .to({ framecount: COUNT_FRAME_MAX - 1 }, DELAY_SWITCH)
      .onUpdate(o => updateSpriteSheet(this.sprite, '274px', o.framecount))
      .onStart(() => this.onStart())
      .onComplete(() => this.onComplete())
      .start()
  }

  show () {
    if (this.state === STATE_SHOW) return
    const initWord = word => {
      word.style.opacity = 0
      word.style.pointerEvents = 'none'
    }
    const onShow = word => {
      easeInWord(word, () => { word.style.pointerEvents = 'auto' })
    }
    this.state = STATE_SHOW
    this.words.map(initWord)
    this.timeoutActionLoop = setTimeout(() => this.timeline.startLoop(), DELAY_ACTION_LOOP)
    this.timeoutActionShow = setTimeout(() => this.words.map(onShow), DELAY_SHOW)
  }

  hide (bookCloseMode = false) {
    if (this.state === STATE_HIDE_INTRO || this.state === STATE_HIDE || this.state === STATE_HIDE_BOOK_CLOSE) return
    const onComplete = () => this.state = STATE_HIDE
    clearTimeout(this.timeoutActionLoop)
    clearTimeout(this.timeoutActionShow)
    this.state = bookCloseMode ? STATE_HIDE_BOOK_CLOSE : STATE_HIDE_INTRO
    this.words.map(word => easeOutWord(word,null, null, 600))
    if (bookCloseMode) return
    setTimeout(onComplete, DELAY_HIDE)
  }

  update (time, delta) {
    if (this.state === STATE_HIDE_BOOK_CLOSE || this.state === STATE_HIDE_INTRO) return
    this.view.style.transform = `scale(${Math.min(getScreenRatio(), 1)})`
    this.timeline.update(time, delta)
  }
}
export default Action


// WEBPACK FOOTER //
// ./src/scripts/Action.js